import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "input", "hidden"];

  connect() {
    this.toggleAppellation();
    if (this.hasCheckboxTarget) {
      this.checkboxTarget.addEventListener(
        "change",
        this.toggleAppellation.bind(this)
      );
    }
  }

  toggleAppellation() {
    if (this.hasCheckboxTarget && this.hasInputTarget && this.hasHiddenTarget) {
      if (this.checkboxTarget.checked) {
        this.inputTarget.value = "";
        this.hiddenTarget.value = "";
        this.inputTarget.disabled = true;
      } else {
        this.inputTarget.disabled = false;
      }
    }
  }
}
